import { render } from "./Loading.vue?vue&type=template&id=794c24e9&scoped=true"
const script = {}

import "./Loading.scss?vue&type=style&index=0&id=794c24e9&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794c24e9"]])

export default __exports__